import { Component, OnInit, Input } from '@angular/core';
import { AdminServiceService } from 'src/app/_services/AdminService.service';
import { AlertifyService } from 'src/app/_services/alertify.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-photoApiSubscriptions',
  templateUrl: './photoApiSubscriptions.component.html',
  styleUrls: ['./photoApiSubscriptions.component.css']
})
export class PhotoApiSubscriptionsComponent implements OnInit {

  isSaving = false;
  @Input() currentProject: any;
  @Input() currentApiId: any;
  currentConfiguration: any;
  currentLocationName: string;
  selectedLocation: any;
  mediaCollection = new Array<any>();

  
  constructor(private _adminService: AdminServiceService, private _alertify: AlertifyService) { }

  ngOnInit() {
    if (this.currentProject.id  <= 0)
    {
      this.currentConfiguration = {
        id: 0,
        name: "",
        contentLocations: new Array<any>()
      };
    }
    else {
      //Load Current Configuration....
      this._adminService.getPhotosConfiguration(this.currentProject.apiKey).subscribe(response => {

        if (response) {
          
          this.currentConfiguration = response;

          if (!this.currentConfiguration.contentLocations)
          {
            this.currentConfiguration.contentLocations = new Array<any>();
          }

        } else {
          this.currentConfiguration = {
            id: 0,
            name: "",
            contentLocations: new Array<any>()
          };          
        }
      });

    }
  }

  onAddLocation() {
    this.currentConfiguration.contentLocations.push({
      id: 0,
      name: this.currentLocationName
    });

    this.currentLocationName = "";
  }

  onContentLocation(location) {
    this.selectedLocation = location;

    this._adminService.getPhotosFromMediaContainer(this.currentProject.projectShortName, location.name, this.currentProject.apiKey).subscribe(response => {
      this.mediaCollection = new Array();
      for(var itm in response) {
        var path = environment.media_url + this.currentProject.projectShortName + "/" + location.name + "/" + response[itm];
        this.mediaCollection.push(path);
      }
    });
    
  }

  onSubscriptionAdded(event) {
    this.isSaving = true;

    this._adminService.addSubscription(event).subscribe(response => {
      this.currentProject.id = response["id"];
      this.currentProject.apiKey = response["apiKey"];

      this._alertify.success("Subscription was created.");
      this.isSaving = false;

    }, error => {
      this._alertify.error(error);
      this.isSaving = false;
    });

  }

  onSave() {
    console.log('saving...', this.currentProject, this.currentConfiguration);
    this._adminService.savePhotosConfiguration(this.currentProject.projectShortName, this.currentProject.apiKey, this.currentConfiguration).subscribe(response => {
      console.log('saved...', response);
      this.currentConfiguration.id = response["id"];

      this.currentConfiguration.contentLocations = response["contentLocations"];
    });
  }

}

